var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEdit = function SvgIconEdit(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B5C4",
    fillRule: "nonzero",
    d: "M16.515.94A3.18 3.18 0 0 0 14.248 0c-.856 0-1.66.333-2.266.938l-9.64 9.584a.54.54 0 0 0-.128.2l-2.181 6a.547.547 0 0 0 .673.709l5.426-1.665a.545.545 0 0 0 .226-.135L16.515 5.474c.607-.605.94-1.411.94-2.268 0-.856-.333-1.661-.94-2.267zM5.505 14.816l-2.031.624a2.33 2.33 0 0 0-.554-.906 2.948 2.948 0 0 0-.74-.524l.93-2.556h1.254v1.09c0 .302.244.546.546.546h.962l-.367 1.726zm8.03-7.906l-6.647 6.646.191-.898A.546.546 0 0 0 6.546 12H5.455v-1.09a.546.546 0 0 0-.545-.546h-.861l6.487-6.45.006.006c.4-.4.932-.62 1.496-.62a2.1 2.1 0 0 1 1.496.62c.398.4.62.93.62 1.496 0 .565-.22 1.096-.62 1.495zm2.208-2.209l-.508.51a3.184 3.184 0 0 0-.929-2.064 3.178 3.178 0 0 0-2.066-.929l.512-.507.001-.001c.398-.4.93-.62 1.495-.62.565 0 1.097.22 1.495.62.4.4.621.93.621 1.495 0 .566-.22 1.097-.62 1.496zm-3.583-.179L6.706 9.978a.545.545 0 1 0 .771.771l5.455-5.454a.545.545 0 1 0-.772-.772z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-edit.f61a87ed.svg";
export { ForwardRef as ReactComponent };